/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/phone/sheets/QaPhoneStandardChecksSheet.tsx
 * FILE_ID: JOBHUB-QA-PHONE-STANDARD-CHECKS-001
 * PURPOSE: Phone list of standard check sets. A tap adds that set to the open checklist.
 */
import { MobileSheet } from '@quotech/ui'
import { useQaStandardChecks } from '../../useQaStandardChecks'
import type { JobQaTabController } from '../../useJobQaTabController'
import { Row } from './QaPhoneMoreSheet'

export function QaPhoneStandardChecksSheet({
  open,
  onClose,
  controller,
}: {
  open: boolean
  onClose: () => void
  controller: JobQaTabController
}) {
  const checks = useQaStandardChecks(controller)
  const ready = Boolean(checks.targetId())
  return (
    <MobileSheet open={open} onClose={onClose} title="Standard checks">
      <div className="divide-y divide-border py-1">
        {checks.loading ? <p className="px-3 py-3 text-sm text-muted-foreground">Loading…</p> : null}
        {checks.failed ? <p className="px-3 py-3 text-sm text-destructive">Could not load standard checks.</p> : null}
        {!ready && !checks.loading ? <p className="px-3 py-3 text-sm text-muted-foreground">Pick a checklist first.</p> : null}
        {checks.sets.map((set) => (
          <Row
            key={set.key}
            id={`qa-phone-standard-${set.key}`}
            label={`${set.title} (${set.count})`}
            onClick={() => {
              if (!ready) return
              void checks.add(set.key).then(() => onClose())
            }}
          />
        ))}
      </div>
    </MobileSheet>
  )
}
